<template>
  <div class="container mx-auto mt-28 text-center">
    <h1>Clip</h1>
    <h2><small>Generate a new online clipboard with one click</small></h2>
    <button @click="generate">Generate</button>
  </div>
</template>

<script setup>
import http from '../../helpers/http.js'
import {router} from '@inertiajs/vue3'

  
let generate = () => {
  http.post('/clips').then(({data}) => {
    router.visit(`/clips/${data.token}`)
  })
}

</script>